import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import MeterUsageLine from './MeterUsageLine';
import { useGetSubscriptionUsageHandler } from '../dataHandlers/getSubscriptionUsageHandler';

export default function SubscriptionInvoiceUsageCell({ subscriptionId, stripeInvoiceId }) {
  const { usage, isLoading, isError } = useGetSubscriptionUsageHandler(
    subscriptionId,
    { stripe_invoice_id: stripeInvoiceId },
    { enabled: Boolean(subscriptionId && stripeInvoiceId) },
  );

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (isError || !usage?.items?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5}>
      {usage.items.map((item) => (
        <MeterUsageLine key={item.meter_id} {...item} />
      ))}
    </Stack>
  );
}
